module.exports = __webpack_public_path__ + "img/03_full.09e8633e.jpg";